import { useEffect, useState } from "react";
import useDataBean from "../../../core/services/dataBean/useDataBean";
import { toast } from "react-toastify";
import { ListMenu } from "../../theme/Component/ListMenu";
import { BasicTable } from "../../theme/Component/BasicTable";
import { Modal } from "../../theme/Component/Modal";
import { ModalConfirm } from "../../theme/Component/ModalConfirm";
import { _AgreementBalance } from "../../../core/services/dataBean/EntityCatalogVdos";
import { InputMoney } from "../../theme/Input/InputMoney";
import { _Project, _single } from "../../../core/services/dataBean/EntityCatalog";
import { SelectContractModifyType } from "../ContractModifyType/SelectContractModifyType";
import { FileInput } from "../../theme/Component/FileInput";
import { FileService } from "../../../core/services/FileService";
import { InputDate } from "../../theme/Input/InputDate";
import { Singleton } from "../../../core/services/Singleton";
import useModal, { MODAL_LG } from "../../theme/Component/hooks/useModal";
import { DropDown } from "../../theme/Component/DropDown";
import { DownloadFileCard } from "../../theme/Component/DownloadFileCard";

interface Props {
    IDProject: number;
    project?:any;
}

export const AgreementBalance = ({ IDProject,project }: Props) => {


    const { instance, lista, setLista, bean, setBean, update, handleChange } = useDataBean(_AgreementBalance);
    const { instance: instanceProject } = useDataBean(_Project);
    const file = new FileService();
    const single = Singleton.getInstance();
    const [beneficiario, setbeneficiario] = useState<any>({ name: 'Editar', tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [cronograma, setcronograma] = useState<any>({ name: 'cronograma', tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modal, setModal] = useState<any>({ name: 'Editar', tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modalC, setModalC] = useState<any>({ name: '', tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-sm' });

    const modalExcel = useModal(`Reporte de modificaciones de proyecto`, MODAL_LG);

    useEffect(() => {
        getLista()

    }, [IDProject])


    const getLista = () => {

        instance.getAgreementBalanceCatalogoPorPropiedadesRender({ State: 1, IDProject: IDProject }, null).then(
            (resp: any) => {
                if (resp) {
                    if (resp && resp.length > 0) {
                        resp.forEach((element: any) => {
                            if (element.DataBeanProperties.Media != null && element.DataBeanProperties.MediaContext != '') {
                                element.DataBeanProperties.URL = `<a href="${file.getUrlFile(element.DataBeanProperties.MediaContext, element.DataBeanProperties.Media)}" target="_blank">Ver</a>`;
                            }
                        });
                        setLista(resp)
                    } else {
                        setLista([])
                    }
                }

            }
        )

    }

    const create = () => {
        setBean({
            State: 1,
            IDProject: IDProject,
            IDEmployee: _single.getAccountID(),
            UptoDate: project?.UptoDate 
            // Since: single.getCurrenDate()
        });
        setModal({ ...modal, "view": true });
    }

    const editaItem = () => {

        update().then(
            (resp: any) => {
                getLista();
                setModal({ ...modal, "view": false });
            }
        ).catch(err => {
            toast.error(err);
        })

    }
    const deleteItem = () => {
        bean.State = 2;
        bean.IDEmployee = _single.getAccountID();
        editaItem();
        setModalC({ ...modalC, "view": false });
    }


    const head = [
        { title: 'ID', property: 'IDAgreementBalance', visible: true },
        { title: 'Proyecto', property: 'ProjectName', visible: false },        
        // { title: 'Fecha Registro', property: 'Since', visible: true },
        { title: 'Tipo', property: 'BalanceTypeName', visible: true },
        { title: 'Descripción', property: 'Descripction', visible: true },
        { title: 'Valor', property: 'AmountBalance', visible: true },
        { title: 'Fecha Final', property: 'UptoDate', visible: true },
        { title: 'Adjunto', property: 'URL', visible: true },
        { title: 'Usuario Modificador', property: 'EmployeeName', visible: true },

    ]

    const iconButtonsItem = [
        { nombre: 'Agregar', visible: _single.canCreate(), icono: 'ri-file-add-line', evento: create }
    ]
    const listaBotones = () => {
        const botones = [

            { titulo: 'Editar', icono: 'ri-edit-2-line', visible: _single.canEdit(), evento: () => { setModal({ ...modal, "view": true }) } },
            { titulo: 'Eliminar', icono: 'ri-delete-bin-line', visible: _single.canDelete(), evento: () => { setModalC({ ...modalC, "view": true }) } },


        ]
        return (
            <ListMenu listaBotones={botones} />
        )
    }

    const [excelDocument, setExcelDocument] = useState<any>(null);
    const [excelError, setExcelError] = useState<string | null>(null);

    const getExcel = () => {
        setExcelDocument(null);
        setExcelError(null);

        instanceProject.getProjectModificationReport(_single.getAccountID(), IDProject).then(
            (resp: any) => {
                console.log(resp)
                const document = resp;

                if (!document?.URL) {
                    setExcelError(document?.ERR ?? "No se genero el archivo Correctamente");
                    modalExcel.open();
                    return;
                }

                setExcelDocument(document);
                modalExcel.open();
            }
        ).catch((err: any) => {
            setExcelError(err?.message ?? String(err ?? "Error desconocido al generar el archivo"));
            modalExcel.open();
        })
    }

    const buttons = () => {
        return (
            <div className="row">
                <div className="col-md-12">
                    {_single.canExport() &&
                        <DropDown lista={actionsDropDown} eventClick={actions}></DropDown>
                    }
                </div>
            </div>
        )
    }

    const actionsDropDown = [
        { id: 1, name: 'Descargar Detallado', permiso: null, activo: true },

    ];

    const actions = (e: any) => {

        if (e.id === 1) {
            getExcel();
        }
    }

    return (

        <div className="row">

            <div className="col-md-12">

                <BasicTable headButtons={buttons()} body={lista} head={head} rowSet={setBean} listButtons={listaBotones()} iconButtons={iconButtonsItem} ></BasicTable>
                <Modal modal={modal} updateModal={setModal} eventModal={editaItem}>
                    <>
                        <div className="row">
                            <div className="col-md-6">
                                <label>Tipo Registro</label>
                                <SelectContractModifyType label="Tipo de Modificación" idSelector={bean.BalanceType} onChange={(e) => { setBean({ ...bean, 'BalanceType': e }) }} />
                            </div>

                            <div className="col-md-6">
                                <InputMoney _value={bean.AmountBalance} onChange={(e) => { setBean({ ...bean, "AmountBalance": e }) }} />
                            </div>
                            <div className="col-md-6">
                                <InputDate label="Fecha Final" name="UptoDate"
                                    value={bean.UptoDate} setDate={(e) => { setBean({ ...bean, "UptoDate": e }) }} />
                            </div>
                            <div className="col-md-12">
                                <label>Descripción</label>
                                <textarea name="Descripction" className="form-control" value={bean.Descripction} onChange={handleChange} />
                            </div>
                            <div className="col-md-12">
                                <FileInput docAcept={['application/pdf']} Media={bean.Media} MediaContext={bean.MediaContext}
                                    onCreate={(e) => { setBean({ ...bean, "Media": e.Media, "MediaContext": e.MediaContext }) }} label="Adjunto / Soporte" directory="projectAttachment" />
                            </div>
                        </div>
                    </>
                </Modal>


                <ModalConfirm modal={modalC} updateModal={setModalC} eventModal={deleteItem}>
                    <strong>Eliminar item</strong>
                </ModalConfirm>

                <Modal modal={modalExcel.modal} updateModal={modalExcel.setModal}>
                    <DownloadFileCard
                        file={excelDocument}
                        error={excelError}
                        fallbackName="Reporte.xlsx"
                        fileTypeLabel="Archivo Excel"
                        buttonLabel="Descargar Excel"
                        icon="ri-file-excel-2-line"
                        iconClassName="text-success"
                        buttonClassName="btn-success"
                    />
                </Modal>
            </div>

        </div>

    )
}